import { HelperService } from '../../helper-service';
import { DicLang, ITEM_TYPES } from '../../item/item-types';
import { MESSAGE_TYPES } from '../../item/message-types';
import { AbstractChatMessage } from './abstract-chat-message';
import { DictionaryContent } from './dictionary-content-interface';
import { LeitnerContent } from './leitner-content-interface';
import { LessonContentType } from './lesson-content-type';

export class LeitnerMessage extends AbstractChatMessage{
    content: LeitnerContent;
    constructor(){
        super()
        this.setType(MESSAGE_TYPES.Leitner)
    }
    setContent(data: LeitnerContent){
        if(!data.title){
            const sourceLang = HelperService.isPersian(data.title)?DicLang.fa:DicLang.de
            const targetLang = HelperService.isPersian(data.title)?DicLang.de:DicLang.fa
            const dictionaryContent: DictionaryContent = { type: MESSAGE_TYPES.Dictionary, title : data as unknown as string, sourceLang:sourceLang, targetLang:targetLang}
            this.content = {
                title: data as unknown as string,
                lastReviewDate: new Date(),
                attachments:[dictionaryContent],
                difficulty: 1,
                elapsedDays: 0,
                lapses: 0,
                reps: 0,
                scheduledDays: 1,
                state: 0,
                easinessFactor:2.5,
                stability: 20,
                repetition: 0,
            }
        }
        else {   
            this.content = data;
            if(!this.content.attachments || this.content.attachments.length === 0){
                if (data.title.includes('lesson:')) {
                    // Handle lesson content
                    const lessonContent = data as unknown as LessonContentType;
                    this.content.attachments = [lessonContent];
                } else {
                    // Handle dictionary content
                    const sourceLang = HelperService.isPersian(data.title)?DicLang.fa:DicLang.de
                    const targetLang = HelperService.isPersian(data.title)?DicLang.de:DicLang.fa
                    const dictionaryContent: DictionaryContent = { type: MESSAGE_TYPES.Dictionary, title : data.title, sourceLang:sourceLang, targetLang:targetLang}
                    this.content.attachments = [dictionaryContent]
                }
            }
        }
    }

    getDictionaryContent(): DictionaryContent {
        for(let attachment of this.content.attachments){
            if(attachment["sourceLang"]) {
                return attachment as DictionaryContent;
            }
        }
        return null;
    }

    getLessonContent(): LessonContentType {
        for(let attachment of this.content.attachments){
            if(attachment["type"] === MESSAGE_TYPES.Lesson) {
                return attachment as LessonContentType;
            }

        }
        return null;
    }

    isLessonContent(): boolean {
        return this.getLessonContent() !== null;
    }

    isDictionaryContent(): boolean {
        return this.getDictionaryContent() !== null;
    }

    hasContent(): boolean {
        return this.content.title.length > 0
    }
    getContentString(): string {
        return JSON.stringify(this.content)
    }
    setReviewTime(reviewTime: number) {
        if (!reviewTime) {
            this.scheduledTime = new Date("2050/12/12 12:12:12");
            return true;
        }
        this.scheduledTime = new Date(reviewTime)
    }
    getEasinessFactor() {
        return this.content.easinessFactor;
    }

    getReceivedTimeSqlLiteFormat() {
        return this.receivedTime;
        //        return this.reviewTime.replace(/-/g,"/");
    }

    getLastReviewTimeSqlLiteFormat() {
        return this.content.lastReviewDate;
    }
    getReviewDate() {
        return this.scheduledTime;
    }
    setLastReviewedTime(lastReviewedTime: number) {
        // if (this.lastReviewedTime && lastReviewedTime)
        //     // this.lastReviewedTime = lastReviewedTime.replace(/-/g, "/");
        // else
        //     this.lastReviewedTime = Tools.Time.getToday();
    }

    setEasinessFactor(ef: number) {
        this.content.easinessFactor = ef;
    }

    getStability(): number {
        return this.content.stability || 20; // Default stability value
    }

    setStability(stability: number) {
        this.content.stability = stability;
    }

    getRepetitions(): number {
        return this.content.repetition;
    }

    setRepetitions(repetition: number) {
        this.content.repetition = repetition;
    }

    getInterval(): number {
        return Math.max(1, (this.scheduledTime.getTime() - this.content.lastReviewDate.getTime()) / (24 * 60 * 60 * 1000));
    }

    getNextReviewDate(): Date {
        return this.scheduledTime;
    }

    setNextReviewDate(date: Date) {
        this.scheduledTime = date;
    }
}


